import { Laptop, Moon, Sun } from 'lucide-react'
import { useTheme } from '@/design-system/theme/useTheme'
import type { ThemePreference } from '@/design-system/theme/theme'

const options: readonly {
  value: ThemePreference
  label: string
  icon: typeof Sun
}[] = [
  { value: 'system', label: 'Système', icon: Laptop },
  { value: 'dark', label: 'Sombre', icon: Moon },
  { value: 'light', label: 'Clair', icon: Sun },
]

export function ThemeToggle() {
  const { preference, setPreference } = useTheme()

  return (
    <div className="ds-theme-toggle" role="group" aria-label="Choisir le thème">
      {options.map(({ value, label, icon: Icon }) => (
        <button
          key={value}
          type="button"
          className="ds-theme-toggle__option"
          aria-label={`Thème ${label.toLowerCase()}`}
          aria-pressed={preference === value}
          onClick={() => {
            setPreference(value)
          }}
        >
          <Icon aria-hidden="true" />
          <span>{label}</span>
        </button>
      ))}
    </div>
  )
}
